module.exports = __webpack_public_path__ + "static/media/forwards-icon.923b7b1f.svg";